import React from 'react'
import { useRef, useEffect } from 'react';
import Typed from 'typed.js';

const Title = () => {
    const el = useRef(null);
    useEffect(() => {
        const typed = new Typed(el.current, {
            strings: ['<p>NicholasGitman.com</p>'],
            typeSpeed: 50,
        });

        return () => {
            // Destroy Typed instance during cleanup to stop animation
            typed.destroy();
        };
    }, []);

    return (
        <main id="main" className="relative bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex flex-col md:flex-row items-center justify-center w-full gap-8 sm:gap-10 md:gap-16 py-16 sm:py-20 md:py-24 px-4 sm:px-8 overflow-hidden">
            {/* Decorative background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute -top-1/2 -left-1/2 w-full h-full bg-blue-500/10 rounded-full blur-3xl"></div>
                <div className="absolute -bottom-1/2 -right-1/2 w-full h-full bg-purple-500/10 rounded-full blur-3xl"></div>
            </div>

            {/* Content */}
            <div className="relative z-10 flex flex-col md:flex-row items-center justify-center gap-8 sm:gap-10 md:gap-16 max-w-7xl mx-auto">
                <div className="relative group">
                    <div className="absolute -inset-1 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full blur opacity-75 group-hover:opacity-100 transition duration-500"></div>
                    <img
                        src="/headshot.png"
                        className="relative rounded-full shadow-2xl transform transition-all duration-500 hover:scale-105 w-48 h-48 sm:w-56 sm:h-56 md:w-64 md:h-64 lg:w-80 lg:h-80 object-cover"
                        alt="Headshot of Nicholas Gitman"
                        id="my_image"
                    />
                </div>

                <div className="flex flex-col items-center md:items-start text-center md:text-left space-y-4 sm:space-y-6">
                    <div className="space-y-2">
                        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl text-white font-bold tracking-tight">
                            Nicholas Gitman
                        </h1>
                        <span
                            className="block text-xl sm:text-2xl md:text-4xl lg:text-5xl text-blue-400 font-medium min-h-[1.5em]"
                            ref={el}
                        ></span>
                    </div>
                    <p className="text-base sm:text-lg md:text-xl text-slate-300 max-w-lg leading-relaxed">
                        Computer Science & Applied Math Student at Stony Brook University
                    </p>
                    <div className="flex gap-4 pt-4">
                        <a
                            href="#about-me"
                            className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-lg"
                        >
                            About Me
                        </a>
                        <a
                            href="#contact"
                            className="px-6 py-3 bg-transparent border-2 border-blue-400 hover:bg-blue-400/10 text-blue-400 rounded-lg font-semibold transition-all duration-300 transform hover:scale-105"
                        >
                            Contact
                        </a>
                    </div>
                </div>
            </div>
        </main>
    )
}

export default Title